import React from "react";
import FormattedMessage from "@irati/utils/lang";
import authentication from "@irati/auth";
import { H3 } from "@irati/ui/src/Typography";
import Button from "@irati/ui/src/Button";
import { SectionHeader } from "../styled";
var CompanyNewsTitle = function (_a) {
    var onClickEdit = _a.onClickEdit, _b = _a.onExitEdit, onExitEdit = _b === void 0 ? null : _b, _c = _a.isAdmin, isAdmin = _c === void 0 ? false : _c;
    var tenantName = authentication.userTenant().public_name;
    return (React.createElement(SectionHeader, null,
        React.createElement(H3, null,
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.title", values: { tenant: tenantName } })),
        isAdmin && !onExitEdit && (React.createElement(Button, { primary: true, onClick: onClickEdit },
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.edit", values: { tenant: tenantName } }))),
        isAdmin && onExitEdit && (React.createElement(Button, { primary: true, onClick: onExitEdit },
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.exit" })))));
};
export default CompanyNewsTitle;
